<template>
  <section class="absolute inset-0 top-12 z-20">
    <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16">

      <!--  -->
      <h3
        class="font-berthold-force uppercase font-bold tracking-widest text-white"
        :class="[
          italicTitle ? 'italic' : ''
        ]"
      >

        {{ title ?? 'BEM VINDO A' }}
      </h3>

      <!-- tag -->
      <div>
        <slot name="tag" />
      </div>

      <!-- logo superior -->
      <div class="flex justify-center">
        <slot name="principal" />
      </div>

      <p
        class="mb-8 text-lg font-normal text-white lg:text-xl sm:px-16 lg:px-48 font-berthold-force"
        :class="[
          mtSub ? 'mt-10' : ''
        ]"
      >
        {{ subTitle }}
      </p>

      <div
        class="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0"
      >
        <slot name="descript" />
      </div>

      <!-- buttons -->
      <div
        class="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0"
      >
        <slot name="button" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  title: { String, required: true },
  subTitle: { String, required: false },
  mtSub: { Boolean, default: false },
  italicTitle: { Boolean, default: false }
})

</script>
